import { CategoryRisks } from '@/core/typing'

export const isNewCategory = (val: CategoryRisks) => {
    return val === CategoryRisks.Women || val === CategoryRisks.LGBTQ
}
